var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg-icon',{staticClass:"icon-svg",class:`icon-${_vm.id}`,attrs:{"name":_vm.filepath,"title":_vm.title,"desc":_vm.desc}})
}
var staticRenderFns = []

export { render, staticRenderFns }